import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replaceBaseUrl } from 'ctm-util-functions';
import { resultsConfigSelector } from 'ctm-selectors';
import classNames from 'classnames';
import styles from './price_confidence_banner.css';

/**
 * PriceConfidenceBanner displays a responsive image for price confidence.
 * Uses <picture> and <source> for CSS-based breakpoints.
 * @param {Object} props The properties for the component
 * @returns {Node} The banner component
 */
const _PriceConfidenceBanner = ({ displayMode, experimentId }) => {
    if (experimentId !== 'expPriceConfidenceBanner') {
        // If the experimentId does not match, do not render the banner
        // This is useful for A/B testing scenarios where the banner should only be shown for specific experiments
        return null;
    }

    return (
        <div
            className={classNames(styles.wrapper, {
                [styles.wrapperWithBottomPadding]: displayMode === 'column'
            })}
        >
            <picture>
                <source
                    media="(max-width: 440px)"
                    srcSet={replaceBaseUrl(
                        '/evt/assets/brand/ctm/images/price-confidence-banner-mobile.png'
                    )}
                />
                <source
                    media="(max-width: 850px)"
                    srcSet={replaceBaseUrl(
                        '/evt/assets/brand/ctm/images/price-confidence-banner-tablet.png'
                    )}
                />
                <img
                    className={styles.responsiveImage}
                    src={replaceBaseUrl(
                        '/evt/assets/brand/ctm/images/price-confidence-banner-desktop.png'
                    )}
                    alt="Price Confidence Banner"
                />
            </picture>
        </div>
    );
};

_PriceConfidenceBanner.propTypes = {
    displayMode: PropTypes.string,
    experimentId: PropTypes.string
};

/**
 * Maps the store state to component props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    return {
        displayMode: resultsConfigSelector(state).get('displayMode'),
        experimentId: state.getIn(['page', 'experimentId'])
    };
};

export const PriceConfidenceBanner = connect(mapStateToProps)(_PriceConfidenceBanner);
